import exploreSchemeEn from "./locales/en.json";

export const EXPLORE_SCHEME_NS = "exploreScheme" as const;

export const ExploreSchemeTranslations = {
  en: {
    [EXPLORE_SCHEME_NS]: {
      ...exploreSchemeEn,
    },
  },
};
